import React from "react";
import { TreeSelect } from 'primereact/treeselect';
import CSBaseControl from "./CSBaseControl";
import CSServiceUtil from "../util/CSServiceUtil";
import CSFormUtil from "../util/CSFormUtil";

function cfMapToTreeNodes(lNodes, lLabelField, lKeyField) {
    return lNodes.map(n => ({
        key:      String(n.data[lKeyField]),
        label:    n.data[lLabelField],
        data:     n.data,
        children: n.children
        ? cfMapToTreeNodes(n.children, lLabelField, lKeyField)
        : []
    }));
}


class CSTreeSelect extends CSBaseControl {
    constructor(props) {
        super(props);
        this.state = {
            mValue          : (this.props.pValue !== null) ? String(this.props.pValue) :  null,
            mDependentValue : null,
            mDataProvider   : [],
            mIdObjMap       : null
        };

        this.mServiceUtil     = CSServiceUtil.cfGetInstance();
        this.cfHandleChange   = this.cfHandleChange.bind(this);
        this.cfHandleResponse = this.cfHandleResponse.bind(this);
    }

    componentDidMount() {
        this.cfFetchData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pValue !== this.props.pValue) {
            let lValue = null;
            if(this.props.data_provider_id_ && this.props.selected_data_) {
                lValue = this.props.selected_data_[this.props.data_provider_id_];
            }
            this.setState({ mValue: (lValue) ? String(lValue) :  null });
        }

        let lReload = false;
        if (prevProps.data_provider_source_ !== this.props.data_provider_source_) {
            lReload = true;
        }

        if(this.props.hasOwnProperty('dependent_item_')){
            let lDependentValue = this.props.dependent_item_.mValue;
            if(lDependentValue !== this.state.mDependentValue) {
                lReload = true;
                this.setState({mDependentValue : lDependentValue})
            }
        }

        if(lReload) {
            this.cfFetchData();
        }

        if (this.props.data_provider_source_ === '#COLLECTION#' && prevProps.mDataProvider !== this.props.mDataProvider) {
            this.setState({ mDataProvider: this.props.mDataProvider || [] });
        }
    }

    cfFetchData() {
        const { data_provider_source_, mDataProvider } = this.props;
        if (!data_provider_source_) {
            this.setState({ mDataProvider: [] });
            return;
        }

        if (data_provider_source_ === '#COLLECTION#') {
            this.setState({ mDataProvider: mDataProvider || [] });
        } else {
            this.mServiceUtil.cfGetDataFromDataProvider(data_provider_source_, this.cfHandleResponse);
        }
    }

    cfHandleResponse(lDataProviderId, lCollection) {
        if(lCollection){
            let lFormUtil = CSFormUtil.cfGetInstance();
            if (lDataProviderId === this.props.data_provider_source_) {
                let lDataProvider    = null;
                let lDependentValObj = null;
                let lDependencyFlag  = false;
                let lGroupingField = null;
                let lKeyField      = null;
                let lLabelField    = null;
                let lMapRefId      = null;
                let lIdObjMap      = null;
                if(this.props.pFormItem && this.props.pFormItem.hasOwnProperty('cs_form_item_properties_')) {
                    lGroupingField = null;
                    lKeyField      = null;
                    lLabelField    = this.props.data_provider_display_field_;
                    for(let lInd=0; lInd<this.props.pFormItem.cs_form_item_properties_.length; lInd++){
                        let lProperty = this.props.pFormItem.cs_form_item_properties_[lInd];
                        if(lProperty.property_ === 'grouping_field_'){
                            if(!lGroupingField) {
                                lGroupingField = []
                            }

                            lGroupingField.push(lProperty.value_)
                        }
                        else if(lProperty.property_ === 'key_'){
                            lKeyField = lProperty.value_;
                        }
                        else if(lProperty.property_ === 'map_ref_id_'){
                            lMapRefId = lProperty.value_;
                        }
                    }
                }

                if(lMapRefId){
                    for(let lInd=0; lInd<lCollection.length; lInd++){
                        let lDataObj = lCollection[lInd];
                        if(lDataObj.hasOwnProperty(lMapRefId)){
                            if(!lIdObjMap){
                                lIdObjMap = {}
                            }

                            lDataObj['label'] = lDataObj[lLabelField];
                            lIdObjMap[lDataObj[lMapRefId]] = lDataObj;
                        }
                    }
                }

                if (this.props.hasOwnProperty('cs_form_criteria_properties_')) {
                    let lProperties = this.props.cs_form_criteria_properties_;
                    for (let lfcpInd = 0; lfcpInd < lProperties.length; lfcpInd++) {
                        let lProperty = lProperties[lfcpInd];
                        if (lProperty.type_ === 'dependency') {
                            if (lProperty.value_ && lProperty.selection_property_ && lProperty.mDependentValue) {
                                if (!lDependentValObj) {
                                    lDependentValObj = {}
                                }

                                lDependentValObj[lProperty.selection_property_] = lProperty.mDependentValue;
                            }

                            lDependencyFlag = true;
                        }
                    }
                }

                if (this.props.dependent_field_) {
                    let lDependentValue = null;
                    if(this.props.hasOwnProperty('dependent_item_')){
                        lDependentValue = this.props.dependent_item_.mValue;
                    }

                    if(lDependentValue){
                        for (let ldpInd = 0; ldpInd < lCollection.length; ldpInd++) {
                            let ldpObj = lCollection[ldpInd];
                            let lDependentField = (this.props.reference_field_) ? this.props.reference_field_ : this.props.dependent_field_;
                            if (lDependentField) {
                                if (ldpObj[lDependentField] && (ldpObj[lDependentField] === lDependentValue)) {
                                    if (!lDataProvider) {
                                        lDataProvider = [];
                                    }
    
                                    lDataProvider.push(ldpObj);
                                }
                            }
                        }
                    }
                    else {
                        lDataProvider = lCollection;
                    }
                }
                else if (lDependentValObj) {
                    for (let ldpInd1 = 0; ldpInd1 < lCollection.length; ldpInd1++) {
                        let ldpObj1 = lCollection[ldpInd1];
                        let lKeys = Object.keys(lDependentValObj);
                        let lIncludeFlag = true;
                        for (let lKeyInd = 0; lKeyInd < lKeys.length; lKeyInd++) {
                            let lKey = lKeys[lKeyInd];
                            if (ldpObj1.hasOwnProperty(lKey)) {
                                if (ldpObj1[lKey] !== lDependentValObj[lKey]) {
                                    lIncludeFlag = false;
                                    break;
                                }
                            }
                        }

                        if (lIncludeFlag) {
                            if (!lDataProvider) {
                                lDataProvider = [];
                            }

                            lDataProvider.push(ldpObj1);
                        }
                    }
                }
                else {
                    if (!lDependencyFlag) {
                        lDataProvider = lCollection;
                    }
                }

                if(lGroupingField && lKeyField) {
                    let lGroupingCollection = lFormUtil.cfGetTreeCollection(lDataProvider, lGroupingField, lKeyField, lMapRefId);
                    if(lGroupingCollection && lGroupingCollection.collection) {
                        const lRawData  = lGroupingCollection.collection;
                        const lTreeData = cfMapToTreeNodes(lRawData, lLabelField, lMapRefId)
                        this.setState({ mDataProvider: lTreeData, mIdObjMap : lIdObjMap });
                    }
                }
            }
        }
        else {
            this.setState({mDataProvider: []})
        }
    }

    cfHandleChange(e) {
        const lValue = e.value;
        let lSelectedObj = this.state.mIdObjMap[lValue];
        this.setState({ mValue: lValue });

        if (this.props.pProcessChange) {
            this.props.pProcessChange(
                {
                    control_type_  : 'tree_select',
                    data_field_    : this.props.pDataField,
                    id_            : this.props.pId,
                    value_         : lValue,
                    selected_data_ : lSelectedObj
                }
            );
        }
    }

    render() {
        return (
            <div className="cs-control field grid">
                {super.cfGetControlLabel()}
                <TreeSelect
                    disabled      = { !(this.props.editable_ === '1') }
                    className     = "cs-drop-down"
                    id            = {this.props.pId}
                    value         = {this.state.mValue}
                    options       = {this.state.mDataProvider}
                    onChange      = {this.cfHandleChange}
                    placeholder   = {this.props.pPlaceholder || ''}
                    selectionMode = "single"
                    appendTo      = {document.body}
                    style         = {{ width: this.props.pWidth || '100%' }}
                    filter
                    showClear
                />
            </div>
        );
    }
}

export default CSTreeSelect;
